import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=56eaa23a&scoped=true&"
import script from "./Secondary.vue?vue&type=script&lang=js&"
export * from "./Secondary.vue?vue&type=script&lang=js&"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=56eaa23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eaa23a",
  null
  
)

export default component.exports